import { objToQs } from "../Utils";
import Call from '../Call.v2';

const BidderSourcesBlock = {
    get(filters) {
        return Call(`bidder/sourcesConfig?${objToQs(filters)}`);
    },
    codes() {
        return Call(`bidder/sourcesConfig/codes`);
    }
};

export default BidderSourcesBlock;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderSourcesConfig.js